// extracted by mini-css-extract-plugin
module.exports = {"containerStyle":"CheckBox_containerStyle__eE62J","labelStyle":"CheckBox_labelStyle__bIGhN","checkBox":"CheckBox_checkBox__A3qRN"};